import { Fragment } from "react";
import { Link } from "react-router-dom";

function AffiliatesServicesEarning() {
  return (
    <Fragment>
      <div className="section-landing-light-blue">
        <div className="section-centered-heading">
          <h2>Services you promote</h2>
          <p>Start with one. Grow with everything that follows.</p>
        </div>
        <div className="affiliate-earnings-grid">
          <div className="earning-card">
            <div className="earning-card-heading">
              <h4 className="h4-primary">TAX Filing</h4>
              <h4 className="h4-secundary">with Tax Expert</h4>
            </div>
            <div className="earning-card-number">
              <h4>15%</h4>
              <span>Per Filing</span>
            </div>
            <div className="earning-card-content">
              <div className="earning-card-content-section">
                <h4>Product</h4>
                <p>
                  Expert-guided tax filing through a modern, structured
                  platform.
                </p>
              </div>
              <div className="earning-card-content-section">
                <h4>Audience</h4>
                <p>
                  Individuals navigating complex tax situations who want
                  clarity, accuracy, and real expert support.
                </p>
              </div>
              <div className="earning-card-content-section">
                <h4>Payout</h4>
                <p>
                  Earnings generated as your network completes services through
                  Plaintr, based on a percentage of revenue.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Link to="/sign-up" className="cta-button primary">
          BECOME AN AFFILIATE
        </Link>
      </div>
    </Fragment>
  );
}

export default AffiliatesServicesEarning;
